import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, frame: String }

  open(event) {
    event.preventDefault()
    event.stopPropagation()
    const frame = document.getElementById(this.frameValue)
    if (frame) {
      frame.src = this.urlValue
    }
  }
}
